import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { BookkeeperMessageRow } from "@releve/shared";

/** Load a thread's messages, oldest → newest (direct RLS read). */
export function useBookkeeperMessages(threadId: string | null) {
  return useQuery<BookkeeperMessageRow[]>({
    queryKey: ["bookkeeper-messages", threadId],
    queryFn: async () => {
      if (!threadId) return [];
      const { data, error } = await supabase
        .from("bookkeeper_messages")
        .select("id, thread_id, role, content, created_at, chart_spec, coa_proposal")
        .eq("thread_id", threadId)
        .order("created_at", { ascending: true });
      if (error) throw error;
      return (data ?? []) as BookkeeperMessageRow[];
    },
    enabled: !!threadId,
    staleTime: 30 * 1000,
  });
}
